import styled from "styled-components";

export const BtnApproveWidgetStyled = styled.div`
  text-wrap: nowrap;
`;
